/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DisplayVideoRouteImport } from './routes/display-video'
import { Route as AchDailyRouteImport } from './routes/ach/daily'
import { Route as AchMerchantRejectionsRouteImport } from './routes/ach/merchant-rejections'
import { Route as AchNachaRatesRouteImport } from './routes/ach/nacha-rates'
import { Route as AchReasonCodesRouteImport } from './routes/ach/reason-codes'
import { Route as AchReturnReasonsRouteImport } from './routes/ach/return-reasons'
import { Route as AchReturnsRouteImport } from './routes/ach/returns'
import { Route as AchTrendsRouteImport } from './routes/ach/trends'
import { Route as AchVolumeTrendsRouteImport } from './routes/ach/volume-trends'
import { Route as AlertsRulesRouteImport } from './routes/alerts/rules'
import { Route as BusinessPerformanceClientScorecardRouteImport } from './routes/business-performance/client-scorecard'
import { Route as BusinessPerformanceDmsVolumeRouteImport } from './routes/business-performance/dms-volume'
import { Route as BusinessPerformanceFeatureAdoptionRouteImport } from './routes/business-performance/feature-adoption'
import { Route as BusinessPerformanceGoLiveRampUpRouteImport } from './routes/business-performance/go-live-ramp-up'
import { Route as BusinessPerformanceMerchantWeeklyTiersRouteImport } from './routes/business-performance/merchant-weekly-tiers'
import { Route as BusinessPerformancePaymentOriginRouteImport } from './routes/business-performance/payment-origin'
import { Route as BusinessPerformancePlatformActivityRouteImport } from './routes/business-performance/platform-activity'
import { Route as BusinessPerformanceTpvTcvPeaksRouteImport } from './routes/business-performance/tpv-tcv-peaks'
import { Route as BusinessPerformanceWeeklyTrendsRouteImport } from './routes/business-performance/weekly-trends'
import { Route as CollectionsAccountDelinquencyRouteImport } from './routes/collections/account-delinquency'
import { Route as CollectionsAiDeclineImpactRouteImport } from './routes/collections/ai-decline-impact'
import { Route as CollectionsAiDeclineJourneysRouteImport } from './routes/collections/ai-decline-journeys'
import { Route as CollectionsBlytzcollectAnalyticsRouteImport } from './routes/collections/blytzcollect-analytics'
import { Route as CollectionsPropensityAccuracyRouteImport } from './routes/collections/propensity-accuracy'
import { Route as CollectionsPropensityToPayRouteImport } from './routes/collections/propensity-to-pay'
import { Route as CollectionsScorecardRouteImport } from './routes/collections/scorecard'
import { Route as CompanyTvBoardRouteImport } from './routes/company/tv-board'
import { Route as CsToolsAccountChangeLogRouteImport } from './routes/cs-tools/account-change-log'
import { Route as CsToolsAutopayAccountsRouteImport } from './routes/cs-tools/autopay-accounts'
import { Route as CsToolsCustomerListRouteImport } from './routes/cs-tools/customer-list'
import { Route as CsToolsFollowUpReportRouteImport } from './routes/cs-tools/follow-up-report'
import { Route as CsToolsInboundMessagesRouteImport } from './routes/cs-tools/inbound-messages'
import { Route as CsToolsMerchantNotesRouteImport } from './routes/cs-tools/merchant-notes'
import { Route as CsToolsMerchantUsersRouteImport } from './routes/cs-tools/merchant-users'
import { Route as CsToolsMessageReportRouteImport } from './routes/cs-tools/message-report'
import { Route as CsToolsOptOutSourcesRouteImport } from './routes/cs-tools/opt-out-sources'
import { Route as CsToolsOptOutsRouteImport } from './routes/cs-tools/opt-outs'
import { Route as CsToolsPaymentOriginShareRouteImport } from './routes/cs-tools/payment-origin-share'
import { Route as CsToolsPaymentReportRouteImport } from './routes/cs-tools/payment-report'
import { Route as CsToolsReconciliationRouteImport } from './routes/cs-tools/reconciliation'
import { Route as CsToolsRegistrationsRouteImport } from './routes/cs-tools/registrations'
import { Route as CsToolsTwilioRepliesRouteImport } from './routes/cs-tools/twilio-replies'
import { Route as CsToolsUndeliveredRouteImport } from './routes/cs-tools/undelivered'
import { Route as DisplayNameRouteImport } from './routes/display/$name'
import { Route as EngineeringAgentBoardRouteImport } from './routes/engineering/agent-board'
import { Route as EngineeringServicePerformanceRouteImport } from './routes/engineering/service-performance'
import { Route as EngineeringUnansweredQuestionsRouteImport } from './routes/engineering/unanswered-questions'
import { Route as LabReportChatRouteImport } from './routes/lab/report-chat'
import { Route as LabReportDraftRouteImport } from './routes/lab/report-draft'
import { Route as LabReportDraftsRouteImport } from './routes/lab/report-drafts'
import { Route as MerchantsHubspotSyncRouteImport } from './routes/merchants/hubspot-sync'
import { Route as MerchantsLocationLookupRouteImport } from './routes/merchants/location-lookup'
import { Route as MerchantsLocationsRouteImport } from './routes/merchants/locations'
import { Route as MerchantsMasterListRouteImport } from './routes/merchants/master-list'
import { Route as MerchantsMerchant360RouteImport } from './routes/merchants/merchant-360'
import { Route as MerchantsMerchantSettingsRouteImport } from './routes/merchants/merchant-settings'
import { Route as MerchantsMmpvRouteImport } from './routes/merchants/mmpv'
import { Route as MerchantsOnboardingPipelineRouteImport } from './routes/merchants/onboarding-pipeline'
import { Route as MerchantsPortfolioCalloutsRouteImport } from './routes/merchants/portfolio-callouts'
import { Route as MerchantsProcessorsRouteImport } from './routes/merchants/processors'
import { Route as MerchantsRewindRouteImport } from './routes/merchants/rewind'
import { Route as PaymentsAiDeclineCodesRouteImport } from './routes/payments/ai-decline-codes'
import { Route as PaymentsBinMccFeeReportRouteImport } from './routes/payments/bin-mcc-fee-report'
import { Route as PaymentsMulticardUsageRouteImport } from './routes/payments/multicard-usage'
import { Route as PaymentsPayerExperienceRouteImport } from './routes/payments/payer-experience'
import { Route as PaymentsRetryAnalysisRouteImport } from './routes/payments/retry-analysis'
import { Route as PaymentsRetryAnalysisTsysRouteImport } from './routes/payments/retry-analysis-tsys'
import { Route as PlatformDisplaysRouteImport } from './routes/platform/displays'
import { Route as PlatformJobsRouteImport } from './routes/platform/jobs'
import { Route as ProductAiTextsRouteImport } from './routes/product/ai-texts'
import { Route as ProductDeclinePaymentJourneyRouteImport } from './routes/product/decline-payment-journey'
import { Route as ProductRequestTriageRouteImport } from './routes/product/request-triage'
import { Route as ProductRequestsRouteImport } from './routes/product/requests'
import { Route as RiskChargebackDisputesRouteImport } from './routes/risk/chargeback-disputes'
import { Route as RiskChargebacksByOriginRouteImport } from './routes/risk/chargebacks-by-origin'
import { Route as RiskChargebacksOverviewRouteImport } from './routes/risk/chargebacks-overview'
import { Route as RiskDeclineByMidRouteImport } from './routes/risk/decline-by-mid'
import { Route as RiskDeclineRetriesRouteImport } from './routes/risk/decline-retries'
import { Route as RiskDeclinesRouteImport } from './routes/risk/declines'
import { Route as RiskMerchantOutliersRouteImport } from './routes/risk/merchant-outliers'
import { Route as RiskMerchantProfileRouteImport } from './routes/risk/merchant-profile'
import { Route as RiskMerchantRiskRouteImport } from './routes/risk/merchant-risk'
import { Route as RiskPortfolioRiskKpisRouteImport } from './routes/risk/portfolio-risk-kpis'
import { Route as RiskTransactionScoringRouteImport } from './routes/risk/transaction-scoring'
import { Route as SalesToolsPricingStudioRouteImport } from './routes/sales-tools/pricing-studio'
import { Route as SalesActivityRouteImport } from './routes/sales/activity'
import { Route as SalesBookOnboardingRouteImport } from './routes/sales/book-onboarding'
import { Route as SalesPipelineRouteImport } from './routes/sales/pipeline'
import { Route as SalesScorecardRouteImport } from './routes/sales/scorecard'
import { Route as SalesWinLossRouteImport } from './routes/sales/win-loss'
import { Route as StudioDashboardRouteImport } from './routes/studio/dashboard'
import { Route as StudioDeckRouteImport } from './routes/studio/deck'
import { Route as StudioLibraryRouteImport } from './routes/studio/library'
import { Route as StudioReportRouteImport } from './routes/studio/report'
import { Route as StudioTvRouteImport } from './routes/studio/tv'
import { Route as TransactionMonitoringDuplicateAchRouteImport } from './routes/transaction-monitoring/duplicate-ach'
import { Route as TransactionMonitoringDuplicateCardsRouteImport } from './routes/transaction-monitoring/duplicate-cards'
import { Route as TransactionMonitoringDuplicatePaymentsRouteImport } from './routes/transaction-monitoring/duplicate-payments'
import { Route as TransactionMonitoringHighLowTicketsRouteImport } from './routes/transaction-monitoring/high-low-tickets'
import { Route as TransactionMonitoringOwnerPaymentsRouteImport } from './routes/transaction-monitoring/owner-payments'
import { Route as TransactionMonitoringRepeatCardUsageRouteImport } from './routes/transaction-monitoring/repeat-card-usage'
import { Route as TransactionMonitoringSameDayRepeatsRouteImport } from './routes/transaction-monitoring/same-day-repeats'
import { Route as PlatformDisplaysNameRouteImport } from './routes/platform/displays_.$name'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayVideoRoute = DisplayVideoRouteImport.update({
  id: '/display-video',
  path: '/display-video',
  getParentRoute: () => rootRouteImport,
} as any)
const AchDailyRoute = AchDailyRouteImport.update({
  id: '/ach/daily',
  path: '/ach/daily',
  getParentRoute: () => rootRouteImport,
} as any)
const AchMerchantRejectionsRoute = AchMerchantRejectionsRouteImport.update({
  id: '/ach/merchant-rejections',
  path: '/ach/merchant-rejections',
  getParentRoute: () => rootRouteImport,
} as any)
const AchNachaRatesRoute = AchNachaRatesRouteImport.update({
  id: '/ach/nacha-rates',
  path: '/ach/nacha-rates',
  getParentRoute: () => rootRouteImport,
} as any)
const AchReasonCodesRoute = AchReasonCodesRouteImport.update({
  id: '/ach/reason-codes',
  path: '/ach/reason-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const AchReturnReasonsRoute = AchReturnReasonsRouteImport.update({
  id: '/ach/return-reasons',
  path: '/ach/return-reasons',
  getParentRoute: () => rootRouteImport,
} as any)
const AchReturnsRoute = AchReturnsRouteImport.update({
  id: '/ach/returns',
  path: '/ach/returns',
  getParentRoute: () => rootRouteImport,
} as any)
const AchTrendsRoute = AchTrendsRouteImport.update({
  id: '/ach/trends',
  path: '/ach/trends',
  getParentRoute: () => rootRouteImport,
} as any)
const AchVolumeTrendsRoute = AchVolumeTrendsRouteImport.update({
  id: '/ach/volume-trends',
  path: '/ach/volume-trends',
  getParentRoute: () => rootRouteImport,
} as any)
const AlertsRulesRoute = AlertsRulesRouteImport.update({
  id: '/alerts/rules',
  path: '/alerts/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessPerformanceClientScorecardRoute =
  BusinessPerformanceClientScorecardRouteImport.update({
    id: '/business-performance/client-scorecard',
    path: '/business-performance/client-scorecard',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceDmsVolumeRoute =
  BusinessPerformanceDmsVolumeRouteImport.update({
    id: '/business-performance/dms-volume',
    path: '/business-performance/dms-volume',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceFeatureAdoptionRoute =
  BusinessPerformanceFeatureAdoptionRouteImport.update({
    id: '/business-performance/feature-adoption',
    path: '/business-performance/feature-adoption',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceGoLiveRampUpRoute =
  BusinessPerformanceGoLiveRampUpRouteImport.update({
    id: '/business-performance/go-live-ramp-up',
    path: '/business-performance/go-live-ramp-up',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceMerchantWeeklyTiersRoute =
  BusinessPerformanceMerchantWeeklyTiersRouteImport.update({
    id: '/business-performance/merchant-weekly-tiers',
    path: '/business-performance/merchant-weekly-tiers',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformancePaymentOriginRoute =
  BusinessPerformancePaymentOriginRouteImport.update({
    id: '/business-performance/payment-origin',
    path: '/business-performance/payment-origin',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformancePlatformActivityRoute =
  BusinessPerformancePlatformActivityRouteImport.update({
    id: '/business-performance/platform-activity',
    path: '/business-performance/platform-activity',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceTpvTcvPeaksRoute =
  BusinessPerformanceTpvTcvPeaksRouteImport.update({
    id: '/business-performance/tpv-tcv-peaks',
    path: '/business-performance/tpv-tcv-peaks',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessPerformanceWeeklyTrendsRoute =
  BusinessPerformanceWeeklyTrendsRouteImport.update({
    id: '/business-performance/weekly-trends',
    path: '/business-performance/weekly-trends',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsAccountDelinquencyRoute =
  CollectionsAccountDelinquencyRouteImport.update({
    id: '/collections/account-delinquency',
    path: '/collections/account-delinquency',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsAiDeclineImpactRoute =
  CollectionsAiDeclineImpactRouteImport.update({
    id: '/collections/ai-decline-impact',
    path: '/collections/ai-decline-impact',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsAiDeclineJourneysRoute =
  CollectionsAiDeclineJourneysRouteImport.update({
    id: '/collections/ai-decline-journeys',
    path: '/collections/ai-decline-journeys',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsBlytzcollectAnalyticsRoute =
  CollectionsBlytzcollectAnalyticsRouteImport.update({
    id: '/collections/blytzcollect-analytics',
    path: '/collections/blytzcollect-analytics',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsPropensityAccuracyRoute =
  CollectionsPropensityAccuracyRouteImport.update({
    id: '/collections/propensity-accuracy',
    path: '/collections/propensity-accuracy',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsPropensityToPayRoute =
  CollectionsPropensityToPayRouteImport.update({
    id: '/collections/propensity-to-pay',
    path: '/collections/propensity-to-pay',
    getParentRoute: () => rootRouteImport,
  } as any)
const CollectionsScorecardRoute = CollectionsScorecardRouteImport.update({
  id: '/collections/scorecard',
  path: '/collections/scorecard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyTvBoardRoute = CompanyTvBoardRouteImport.update({
  id: '/company/tv-board',
  path: '/company/tv-board',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsAccountChangeLogRoute = CsToolsAccountChangeLogRouteImport.update({
  id: '/cs-tools/account-change-log',
  path: '/cs-tools/account-change-log',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsAutopayAccountsRoute = CsToolsAutopayAccountsRouteImport.update({
  id: '/cs-tools/autopay-accounts',
  path: '/cs-tools/autopay-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsCustomerListRoute = CsToolsCustomerListRouteImport.update({
  id: '/cs-tools/customer-list',
  path: '/cs-tools/customer-list',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsFollowUpReportRoute = CsToolsFollowUpReportRouteImport.update({
  id: '/cs-tools/follow-up-report',
  path: '/cs-tools/follow-up-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsInboundMessagesRoute = CsToolsInboundMessagesRouteImport.update({
  id: '/cs-tools/inbound-messages',
  path: '/cs-tools/inbound-messages',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMerchantNotesRoute = CsToolsMerchantNotesRouteImport.update({
  id: '/cs-tools/merchant-notes',
  path: '/cs-tools/merchant-notes',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMerchantUsersRoute = CsToolsMerchantUsersRouteImport.update({
  id: '/cs-tools/merchant-users',
  path: '/cs-tools/merchant-users',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsMessageReportRoute = CsToolsMessageReportRouteImport.update({
  id: '/cs-tools/message-report',
  path: '/cs-tools/message-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsOptOutSourcesRoute = CsToolsOptOutSourcesRouteImport.update({
  id: '/cs-tools/opt-out-sources',
  path: '/cs-tools/opt-out-sources',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsOptOutsRoute = CsToolsOptOutsRouteImport.update({
  id: '/cs-tools/opt-outs',
  path: '/cs-tools/opt-outs',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsPaymentOriginShareRoute =
  CsToolsPaymentOriginShareRouteImport.update({
    id: '/cs-tools/payment-origin-share',
    path: '/cs-tools/payment-origin-share',
    getParentRoute: () => rootRouteImport,
  } as any)
const CsToolsPaymentReportRoute = CsToolsPaymentReportRouteImport.update({
  id: '/cs-tools/payment-report',
  path: '/cs-tools/payment-report',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsReconciliationRoute = CsToolsReconciliationRouteImport.update({
  id: '/cs-tools/reconciliation',
  path: '/cs-tools/reconciliation',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsRegistrationsRoute = CsToolsRegistrationsRouteImport.update({
  id: '/cs-tools/registrations',
  path: '/cs-tools/registrations',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsTwilioRepliesRoute = CsToolsTwilioRepliesRouteImport.update({
  id: '/cs-tools/twilio-replies',
  path: '/cs-tools/twilio-replies',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsUndeliveredRoute = CsToolsUndeliveredRouteImport.update({
  id: '/cs-tools/undelivered',
  path: '/cs-tools/undelivered',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayNameRoute = DisplayNameRouteImport.update({
  id: '/display/$name',
  path: '/display/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const EngineeringAgentBoardRoute = EngineeringAgentBoardRouteImport.update({
  id: '/engineering/agent-board',
  path: '/engineering/agent-board',
  getParentRoute: () => rootRouteImport,
} as any)
const EngineeringServicePerformanceRoute =
  EngineeringServicePerformanceRouteImport.update({
    id: '/engineering/service-performance',
    path: '/engineering/service-performance',
    getParentRoute: () => rootRouteImport,
  } as any)
const EngineeringUnansweredQuestionsRoute =
  EngineeringUnansweredQuestionsRouteImport.update({
    id: '/engineering/unanswered-questions',
    path: '/engineering/unanswered-questions',
    getParentRoute: () => rootRouteImport,
  } as any)
const LabReportChatRoute = LabReportChatRouteImport.update({
  id: '/lab/report-chat',
  path: '/lab/report-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftRoute = LabReportDraftRouteImport.update({
  id: '/lab/report-draft',
  path: '/lab/report-draft',
  getParentRoute: () => rootRouteImport,
} as any)
const LabReportDraftsRoute = LabReportDraftsRouteImport.update({
  id: '/lab/report-drafts',
  path: '/lab/report-drafts',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsHubspotSyncRoute = MerchantsHubspotSyncRouteImport.update({
  id: '/merchants/hubspot-sync',
  path: '/merchants/hubspot-sync',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsLocationLookupRoute = MerchantsLocationLookupRouteImport.update({
  id: '/merchants/location-lookup',
  path: '/merchants/location-lookup',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsLocationsRoute = MerchantsLocationsRouteImport.update({
  id: '/merchants/locations',
  path: '/merchants/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsMasterListRoute = MerchantsMasterListRouteImport.update({
  id: '/merchants/master-list',
  path: '/merchants/master-list',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsMerchant360Route = MerchantsMerchant360RouteImport.update({
  id: '/merchants/merchant-360',
  path: '/merchants/merchant-360',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsMerchantSettingsRoute =
  MerchantsMerchantSettingsRouteImport.update({
    id: '/merchants/merchant-settings',
    path: '/merchants/merchant-settings',
    getParentRoute: () => rootRouteImport,
  } as any)
const MerchantsMmpvRoute = MerchantsMmpvRouteImport.update({
  id: '/merchants/mmpv',
  path: '/merchants/mmpv',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsOnboardingPipelineRoute =
  MerchantsOnboardingPipelineRouteImport.update({
    id: '/merchants/onboarding-pipeline',
    path: '/merchants/onboarding-pipeline',
    getParentRoute: () => rootRouteImport,
  } as any)
const MerchantsPortfolioCalloutsRoute =
  MerchantsPortfolioCalloutsRouteImport.update({
    id: '/merchants/portfolio-callouts',
    path: '/merchants/portfolio-callouts',
    getParentRoute: () => rootRouteImport,
  } as any)
const MerchantsProcessorsRoute = MerchantsProcessorsRouteImport.update({
  id: '/merchants/processors',
  path: '/merchants/processors',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsRewindRoute = MerchantsRewindRouteImport.update({
  id: '/merchants/rewind',
  path: '/merchants/rewind',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAiDeclineCodesRoute = PaymentsAiDeclineCodesRouteImport.update({
  id: '/payments/ai-decline-codes',
  path: '/payments/ai-decline-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsBinMccFeeReportRoute = PaymentsBinMccFeeReportRouteImport.update({
  id: '/payments/bin-mcc-fee-report',
  path: '/payments/bin-mcc-fee-report',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsMulticardUsageRoute = PaymentsMulticardUsageRouteImport.update({
  id: '/payments/multicard-usage',
  path: '/payments/multicard-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsPayerExperienceRoute = PaymentsPayerExperienceRouteImport.update({
  id: '/payments/payer-experience',
  path: '/payments/payer-experience',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRetryAnalysisRoute = PaymentsRetryAnalysisRouteImport.update({
  id: '/payments/retry-analysis',
  path: '/payments/retry-analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRetryAnalysisTsysRoute =
  PaymentsRetryAnalysisTsysRouteImport.update({
    id: '/payments/retry-analysis-tsys',
    path: '/payments/retry-analysis-tsys',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlatformDisplaysRoute = PlatformDisplaysRouteImport.update({
  id: '/platform/displays',
  path: '/platform/displays',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformJobsRoute = PlatformJobsRouteImport.update({
  id: '/platform/jobs',
  path: '/platform/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductAiTextsRoute = ProductAiTextsRouteImport.update({
  id: '/product/ai-texts',
  path: '/product/ai-texts',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductDeclinePaymentJourneyRoute =
  ProductDeclinePaymentJourneyRouteImport.update({
    id: '/product/decline-payment-journey',
    path: '/product/decline-payment-journey',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProductRequestTriageRoute = ProductRequestTriageRouteImport.update({
  id: '/product/request-triage',
  path: '/product/request-triage',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductRequestsRoute = ProductRequestsRouteImport.update({
  id: '/product/requests',
  path: '/product/requests',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskChargebackDisputesRoute = RiskChargebackDisputesRouteImport.update({
  id: '/risk/chargeback-disputes',
  path: '/risk/chargeback-disputes',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskChargebacksByOriginRoute = RiskChargebacksByOriginRouteImport.update({
  id: '/risk/chargebacks-by-origin',
  path: '/risk/chargebacks-by-origin',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskChargebacksOverviewRoute = RiskChargebacksOverviewRouteImport.update({
  id: '/risk/chargebacks-overview',
  path: '/risk/chargebacks-overview',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskDeclineByMidRoute = RiskDeclineByMidRouteImport.update({
  id: '/risk/decline-by-mid',
  path: '/risk/decline-by-mid',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskDeclineRetriesRoute = RiskDeclineRetriesRouteImport.update({
  id: '/risk/decline-retries',
  path: '/risk/decline-retries',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskDeclinesRoute = RiskDeclinesRouteImport.update({
  id: '/risk/declines',
  path: '/risk/declines',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskMerchantOutliersRoute = RiskMerchantOutliersRouteImport.update({
  id: '/risk/merchant-outliers',
  path: '/risk/merchant-outliers',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskMerchantProfileRoute = RiskMerchantProfileRouteImport.update({
  id: '/risk/merchant-profile',
  path: '/risk/merchant-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskMerchantRiskRoute = RiskMerchantRiskRouteImport.update({
  id: '/risk/merchant-risk',
  path: '/risk/merchant-risk',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskPortfolioRiskKpisRoute = RiskPortfolioRiskKpisRouteImport.update({
  id: '/risk/portfolio-risk-kpis',
  path: '/risk/portfolio-risk-kpis',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskTransactionScoringRoute = RiskTransactionScoringRouteImport.update({
  id: '/risk/transaction-scoring',
  path: '/risk/transaction-scoring',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesToolsPricingStudioRoute = SalesToolsPricingStudioRouteImport.update({
  id: '/sales-tools/pricing-studio',
  path: '/sales-tools/pricing-studio',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesActivityRoute = SalesActivityRouteImport.update({
  id: '/sales/activity',
  path: '/sales/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesBookOnboardingRoute = SalesBookOnboardingRouteImport.update({
  id: '/sales/book-onboarding',
  path: '/sales/book-onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesPipelineRoute = SalesPipelineRouteImport.update({
  id: '/sales/pipeline',
  path: '/sales/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesScorecardRoute = SalesScorecardRouteImport.update({
  id: '/sales/scorecard',
  path: '/sales/scorecard',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesWinLossRoute = SalesWinLossRouteImport.update({
  id: '/sales/win-loss',
  path: '/sales/win-loss',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioDashboardRoute = StudioDashboardRouteImport.update({
  id: '/studio/dashboard',
  path: '/studio/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioDeckRoute = StudioDeckRouteImport.update({
  id: '/studio/deck',
  path: '/studio/deck',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioLibraryRoute = StudioLibraryRouteImport.update({
  id: '/studio/library',
  path: '/studio/library',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioReportRoute = StudioReportRouteImport.update({
  id: '/studio/report',
  path: '/studio/report',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioTvRoute = StudioTvRouteImport.update({
  id: '/studio/tv',
  path: '/studio/tv',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionMonitoringDuplicateAchRoute =
  TransactionMonitoringDuplicateAchRouteImport.update({
    id: '/transaction-monitoring/duplicate-ach',
    path: '/transaction-monitoring/duplicate-ach',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringDuplicateCardsRoute =
  TransactionMonitoringDuplicateCardsRouteImport.update({
    id: '/transaction-monitoring/duplicate-cards',
    path: '/transaction-monitoring/duplicate-cards',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringDuplicatePaymentsRoute =
  TransactionMonitoringDuplicatePaymentsRouteImport.update({
    id: '/transaction-monitoring/duplicate-payments',
    path: '/transaction-monitoring/duplicate-payments',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringHighLowTicketsRoute =
  TransactionMonitoringHighLowTicketsRouteImport.update({
    id: '/transaction-monitoring/high-low-tickets',
    path: '/transaction-monitoring/high-low-tickets',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringOwnerPaymentsRoute =
  TransactionMonitoringOwnerPaymentsRouteImport.update({
    id: '/transaction-monitoring/owner-payments',
    path: '/transaction-monitoring/owner-payments',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringRepeatCardUsageRoute =
  TransactionMonitoringRepeatCardUsageRouteImport.update({
    id: '/transaction-monitoring/repeat-card-usage',
    path: '/transaction-monitoring/repeat-card-usage',
    getParentRoute: () => rootRouteImport,
  } as any)
const TransactionMonitoringSameDayRepeatsRoute =
  TransactionMonitoringSameDayRepeatsRouteImport.update({
    id: '/transaction-monitoring/same-day-repeats',
    path: '/transaction-monitoring/same-day-repeats',
    getParentRoute: () => rootRouteImport,
  } as any)
const PlatformDisplaysNameRoute = PlatformDisplaysNameRouteImport.update({
  id: '/platform/displays_/$name',
  path: '/platform/displays/$name',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/display-video': typeof DisplayVideoRoute
  '/ach/daily': typeof AchDailyRoute
  '/ach/merchant-rejections': typeof AchMerchantRejectionsRoute
  '/ach/nacha-rates': typeof AchNachaRatesRoute
  '/ach/reason-codes': typeof AchReasonCodesRoute
  '/ach/return-reasons': typeof AchReturnReasonsRoute
  '/ach/returns': typeof AchReturnsRoute
  '/ach/trends': typeof AchTrendsRoute
  '/ach/volume-trends': typeof AchVolumeTrendsRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/business-performance/client-scorecard': typeof BusinessPerformanceClientScorecardRoute
  '/business-performance/dms-volume': typeof BusinessPerformanceDmsVolumeRoute
  '/business-performance/feature-adoption': typeof BusinessPerformanceFeatureAdoptionRoute
  '/business-performance/go-live-ramp-up': typeof BusinessPerformanceGoLiveRampUpRoute
  '/business-performance/merchant-weekly-tiers': typeof BusinessPerformanceMerchantWeeklyTiersRoute
  '/business-performance/payment-origin': typeof BusinessPerformancePaymentOriginRoute
  '/business-performance/platform-activity': typeof BusinessPerformancePlatformActivityRoute
  '/business-performance/tpv-tcv-peaks': typeof BusinessPerformanceTpvTcvPeaksRoute
  '/business-performance/weekly-trends': typeof BusinessPerformanceWeeklyTrendsRoute
  '/collections/account-delinquency': typeof CollectionsAccountDelinquencyRoute
  '/collections/ai-decline-impact': typeof CollectionsAiDeclineImpactRoute
  '/collections/ai-decline-journeys': typeof CollectionsAiDeclineJourneysRoute
  '/collections/blytzcollect-analytics': typeof CollectionsBlytzcollectAnalyticsRoute
  '/collections/propensity-accuracy': typeof CollectionsPropensityAccuracyRoute
  '/collections/propensity-to-pay': typeof CollectionsPropensityToPayRoute
  '/collections/scorecard': typeof CollectionsScorecardRoute
  '/company/tv-board': typeof CompanyTvBoardRoute
  '/cs-tools/account-change-log': typeof CsToolsAccountChangeLogRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/follow-up-report': typeof CsToolsFollowUpReportRoute
  '/cs-tools/inbound-messages': typeof CsToolsInboundMessagesRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/merchant-users': typeof CsToolsMerchantUsersRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-out-sources': typeof CsToolsOptOutSourcesRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-origin-share': typeof CsToolsPaymentOriginShareRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/twilio-replies': typeof CsToolsTwilioRepliesRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/display/$name': typeof DisplayNameRoute
  '/engineering/agent-board': typeof EngineeringAgentBoardRoute
  '/engineering/service-performance': typeof EngineeringServicePerformanceRoute
  '/engineering/unanswered-questions': typeof EngineeringUnansweredQuestionsRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/merchants/hubspot-sync': typeof MerchantsHubspotSyncRoute
  '/merchants/location-lookup': typeof MerchantsLocationLookupRoute
  '/merchants/locations': typeof MerchantsLocationsRoute
  '/merchants/master-list': typeof MerchantsMasterListRoute
  '/merchants/merchant-360': typeof MerchantsMerchant360Route
  '/merchants/merchant-settings': typeof MerchantsMerchantSettingsRoute
  '/merchants/mmpv': typeof MerchantsMmpvRoute
  '/merchants/onboarding-pipeline': typeof MerchantsOnboardingPipelineRoute
  '/merchants/portfolio-callouts': typeof MerchantsPortfolioCalloutsRoute
  '/merchants/processors': typeof MerchantsProcessorsRoute
  '/merchants/rewind': typeof MerchantsRewindRoute
  '/payments/ai-decline-codes': typeof PaymentsAiDeclineCodesRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/payer-experience': typeof PaymentsPayerExperienceRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/payments/retry-analysis-tsys': typeof PaymentsRetryAnalysisTsysRoute
  '/platform/displays': typeof PlatformDisplaysRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/product/ai-texts': typeof ProductAiTextsRoute
  '/product/decline-payment-journey': typeof ProductDeclinePaymentJourneyRoute
  '/product/request-triage': typeof ProductRequestTriageRoute
  '/product/requests': typeof ProductRequestsRoute
  '/risk/chargeback-disputes': typeof RiskChargebackDisputesRoute
  '/risk/chargebacks-by-origin': typeof RiskChargebacksByOriginRoute
  '/risk/chargebacks-overview': typeof RiskChargebacksOverviewRoute
  '/risk/decline-by-mid': typeof RiskDeclineByMidRoute
  '/risk/decline-retries': typeof RiskDeclineRetriesRoute
  '/risk/declines': typeof RiskDeclinesRoute
  '/risk/merchant-outliers': typeof RiskMerchantOutliersRoute
  '/risk/merchant-profile': typeof RiskMerchantProfileRoute
  '/risk/merchant-risk': typeof RiskMerchantRiskRoute
  '/risk/portfolio-risk-kpis': typeof RiskPortfolioRiskKpisRoute
  '/risk/transaction-scoring': typeof RiskTransactionScoringRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
  '/sales/activity': typeof SalesActivityRoute
  '/sales/book-onboarding': typeof SalesBookOnboardingRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/scorecard': typeof SalesScorecardRoute
  '/sales/win-loss': typeof SalesWinLossRoute
  '/studio/dashboard': typeof StudioDashboardRoute
  '/studio/deck': typeof StudioDeckRoute
  '/studio/library': typeof StudioLibraryRoute
  '/studio/report': typeof StudioReportRoute
  '/studio/tv': typeof StudioTvRoute
  '/transaction-monitoring/duplicate-ach': typeof TransactionMonitoringDuplicateAchRoute
  '/transaction-monitoring/duplicate-cards': typeof TransactionMonitoringDuplicateCardsRoute
  '/transaction-monitoring/duplicate-payments': typeof TransactionMonitoringDuplicatePaymentsRoute
  '/transaction-monitoring/high-low-tickets': typeof TransactionMonitoringHighLowTicketsRoute
  '/transaction-monitoring/owner-payments': typeof TransactionMonitoringOwnerPaymentsRoute
  '/transaction-monitoring/repeat-card-usage': typeof TransactionMonitoringRepeatCardUsageRoute
  '/transaction-monitoring/same-day-repeats': typeof TransactionMonitoringSameDayRepeatsRoute
  '/platform/displays/$name': typeof PlatformDisplaysNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/display-video': typeof DisplayVideoRoute
  '/ach/daily': typeof AchDailyRoute
  '/ach/merchant-rejections': typeof AchMerchantRejectionsRoute
  '/ach/nacha-rates': typeof AchNachaRatesRoute
  '/ach/reason-codes': typeof AchReasonCodesRoute
  '/ach/return-reasons': typeof AchReturnReasonsRoute
  '/ach/returns': typeof AchReturnsRoute
  '/ach/trends': typeof AchTrendsRoute
  '/ach/volume-trends': typeof AchVolumeTrendsRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/business-performance/client-scorecard': typeof BusinessPerformanceClientScorecardRoute
  '/business-performance/dms-volume': typeof BusinessPerformanceDmsVolumeRoute
  '/business-performance/feature-adoption': typeof BusinessPerformanceFeatureAdoptionRoute
  '/business-performance/go-live-ramp-up': typeof BusinessPerformanceGoLiveRampUpRoute
  '/business-performance/merchant-weekly-tiers': typeof BusinessPerformanceMerchantWeeklyTiersRoute
  '/business-performance/payment-origin': typeof BusinessPerformancePaymentOriginRoute
  '/business-performance/platform-activity': typeof BusinessPerformancePlatformActivityRoute
  '/business-performance/tpv-tcv-peaks': typeof BusinessPerformanceTpvTcvPeaksRoute
  '/business-performance/weekly-trends': typeof BusinessPerformanceWeeklyTrendsRoute
  '/collections/account-delinquency': typeof CollectionsAccountDelinquencyRoute
  '/collections/ai-decline-impact': typeof CollectionsAiDeclineImpactRoute
  '/collections/ai-decline-journeys': typeof CollectionsAiDeclineJourneysRoute
  '/collections/blytzcollect-analytics': typeof CollectionsBlytzcollectAnalyticsRoute
  '/collections/propensity-accuracy': typeof CollectionsPropensityAccuracyRoute
  '/collections/propensity-to-pay': typeof CollectionsPropensityToPayRoute
  '/collections/scorecard': typeof CollectionsScorecardRoute
  '/company/tv-board': typeof CompanyTvBoardRoute
  '/cs-tools/account-change-log': typeof CsToolsAccountChangeLogRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/follow-up-report': typeof CsToolsFollowUpReportRoute
  '/cs-tools/inbound-messages': typeof CsToolsInboundMessagesRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/merchant-users': typeof CsToolsMerchantUsersRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-out-sources': typeof CsToolsOptOutSourcesRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-origin-share': typeof CsToolsPaymentOriginShareRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/twilio-replies': typeof CsToolsTwilioRepliesRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/display/$name': typeof DisplayNameRoute
  '/engineering/agent-board': typeof EngineeringAgentBoardRoute
  '/engineering/service-performance': typeof EngineeringServicePerformanceRoute
  '/engineering/unanswered-questions': typeof EngineeringUnansweredQuestionsRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/merchants/hubspot-sync': typeof MerchantsHubspotSyncRoute
  '/merchants/location-lookup': typeof MerchantsLocationLookupRoute
  '/merchants/locations': typeof MerchantsLocationsRoute
  '/merchants/master-list': typeof MerchantsMasterListRoute
  '/merchants/merchant-360': typeof MerchantsMerchant360Route
  '/merchants/merchant-settings': typeof MerchantsMerchantSettingsRoute
  '/merchants/mmpv': typeof MerchantsMmpvRoute
  '/merchants/onboarding-pipeline': typeof MerchantsOnboardingPipelineRoute
  '/merchants/portfolio-callouts': typeof MerchantsPortfolioCalloutsRoute
  '/merchants/processors': typeof MerchantsProcessorsRoute
  '/merchants/rewind': typeof MerchantsRewindRoute
  '/payments/ai-decline-codes': typeof PaymentsAiDeclineCodesRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/payer-experience': typeof PaymentsPayerExperienceRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/payments/retry-analysis-tsys': typeof PaymentsRetryAnalysisTsysRoute
  '/platform/displays': typeof PlatformDisplaysRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/product/ai-texts': typeof ProductAiTextsRoute
  '/product/decline-payment-journey': typeof ProductDeclinePaymentJourneyRoute
  '/product/request-triage': typeof ProductRequestTriageRoute
  '/product/requests': typeof ProductRequestsRoute
  '/risk/chargeback-disputes': typeof RiskChargebackDisputesRoute
  '/risk/chargebacks-by-origin': typeof RiskChargebacksByOriginRoute
  '/risk/chargebacks-overview': typeof RiskChargebacksOverviewRoute
  '/risk/decline-by-mid': typeof RiskDeclineByMidRoute
  '/risk/decline-retries': typeof RiskDeclineRetriesRoute
  '/risk/declines': typeof RiskDeclinesRoute
  '/risk/merchant-outliers': typeof RiskMerchantOutliersRoute
  '/risk/merchant-profile': typeof RiskMerchantProfileRoute
  '/risk/merchant-risk': typeof RiskMerchantRiskRoute
  '/risk/portfolio-risk-kpis': typeof RiskPortfolioRiskKpisRoute
  '/risk/transaction-scoring': typeof RiskTransactionScoringRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
  '/sales/activity': typeof SalesActivityRoute
  '/sales/book-onboarding': typeof SalesBookOnboardingRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/scorecard': typeof SalesScorecardRoute
  '/sales/win-loss': typeof SalesWinLossRoute
  '/studio/dashboard': typeof StudioDashboardRoute
  '/studio/deck': typeof StudioDeckRoute
  '/studio/library': typeof StudioLibraryRoute
  '/studio/report': typeof StudioReportRoute
  '/studio/tv': typeof StudioTvRoute
  '/transaction-monitoring/duplicate-ach': typeof TransactionMonitoringDuplicateAchRoute
  '/transaction-monitoring/duplicate-cards': typeof TransactionMonitoringDuplicateCardsRoute
  '/transaction-monitoring/duplicate-payments': typeof TransactionMonitoringDuplicatePaymentsRoute
  '/transaction-monitoring/high-low-tickets': typeof TransactionMonitoringHighLowTicketsRoute
  '/transaction-monitoring/owner-payments': typeof TransactionMonitoringOwnerPaymentsRoute
  '/transaction-monitoring/repeat-card-usage': typeof TransactionMonitoringRepeatCardUsageRoute
  '/transaction-monitoring/same-day-repeats': typeof TransactionMonitoringSameDayRepeatsRoute
  '/platform/displays/$name': typeof PlatformDisplaysNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/display-video': typeof DisplayVideoRoute
  '/ach/daily': typeof AchDailyRoute
  '/ach/merchant-rejections': typeof AchMerchantRejectionsRoute
  '/ach/nacha-rates': typeof AchNachaRatesRoute
  '/ach/reason-codes': typeof AchReasonCodesRoute
  '/ach/return-reasons': typeof AchReturnReasonsRoute
  '/ach/returns': typeof AchReturnsRoute
  '/ach/trends': typeof AchTrendsRoute
  '/ach/volume-trends': typeof AchVolumeTrendsRoute
  '/alerts/rules': typeof AlertsRulesRoute
  '/business-performance/client-scorecard': typeof BusinessPerformanceClientScorecardRoute
  '/business-performance/dms-volume': typeof BusinessPerformanceDmsVolumeRoute
  '/business-performance/feature-adoption': typeof BusinessPerformanceFeatureAdoptionRoute
  '/business-performance/go-live-ramp-up': typeof BusinessPerformanceGoLiveRampUpRoute
  '/business-performance/merchant-weekly-tiers': typeof BusinessPerformanceMerchantWeeklyTiersRoute
  '/business-performance/payment-origin': typeof BusinessPerformancePaymentOriginRoute
  '/business-performance/platform-activity': typeof BusinessPerformancePlatformActivityRoute
  '/business-performance/tpv-tcv-peaks': typeof BusinessPerformanceTpvTcvPeaksRoute
  '/business-performance/weekly-trends': typeof BusinessPerformanceWeeklyTrendsRoute
  '/collections/account-delinquency': typeof CollectionsAccountDelinquencyRoute
  '/collections/ai-decline-impact': typeof CollectionsAiDeclineImpactRoute
  '/collections/ai-decline-journeys': typeof CollectionsAiDeclineJourneysRoute
  '/collections/blytzcollect-analytics': typeof CollectionsBlytzcollectAnalyticsRoute
  '/collections/propensity-accuracy': typeof CollectionsPropensityAccuracyRoute
  '/collections/propensity-to-pay': typeof CollectionsPropensityToPayRoute
  '/collections/scorecard': typeof CollectionsScorecardRoute
  '/company/tv-board': typeof CompanyTvBoardRoute
  '/cs-tools/account-change-log': typeof CsToolsAccountChangeLogRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/cs-tools/customer-list': typeof CsToolsCustomerListRoute
  '/cs-tools/follow-up-report': typeof CsToolsFollowUpReportRoute
  '/cs-tools/inbound-messages': typeof CsToolsInboundMessagesRoute
  '/cs-tools/merchant-notes': typeof CsToolsMerchantNotesRoute
  '/cs-tools/merchant-users': typeof CsToolsMerchantUsersRoute
  '/cs-tools/message-report': typeof CsToolsMessageReportRoute
  '/cs-tools/opt-out-sources': typeof CsToolsOptOutSourcesRoute
  '/cs-tools/opt-outs': typeof CsToolsOptOutsRoute
  '/cs-tools/payment-origin-share': typeof CsToolsPaymentOriginShareRoute
  '/cs-tools/payment-report': typeof CsToolsPaymentReportRoute
  '/cs-tools/reconciliation': typeof CsToolsReconciliationRoute
  '/cs-tools/registrations': typeof CsToolsRegistrationsRoute
  '/cs-tools/twilio-replies': typeof CsToolsTwilioRepliesRoute
  '/cs-tools/undelivered': typeof CsToolsUndeliveredRoute
  '/display/$name': typeof DisplayNameRoute
  '/engineering/agent-board': typeof EngineeringAgentBoardRoute
  '/engineering/service-performance': typeof EngineeringServicePerformanceRoute
  '/engineering/unanswered-questions': typeof EngineeringUnansweredQuestionsRoute
  '/lab/report-chat': typeof LabReportChatRoute
  '/lab/report-draft': typeof LabReportDraftRoute
  '/lab/report-drafts': typeof LabReportDraftsRoute
  '/merchants/hubspot-sync': typeof MerchantsHubspotSyncRoute
  '/merchants/location-lookup': typeof MerchantsLocationLookupRoute
  '/merchants/locations': typeof MerchantsLocationsRoute
  '/merchants/master-list': typeof MerchantsMasterListRoute
  '/merchants/merchant-360': typeof MerchantsMerchant360Route
  '/merchants/merchant-settings': typeof MerchantsMerchantSettingsRoute
  '/merchants/mmpv': typeof MerchantsMmpvRoute
  '/merchants/onboarding-pipeline': typeof MerchantsOnboardingPipelineRoute
  '/merchants/portfolio-callouts': typeof MerchantsPortfolioCalloutsRoute
  '/merchants/processors': typeof MerchantsProcessorsRoute
  '/merchants/rewind': typeof MerchantsRewindRoute
  '/payments/ai-decline-codes': typeof PaymentsAiDeclineCodesRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/payments/multicard-usage': typeof PaymentsMulticardUsageRoute
  '/payments/payer-experience': typeof PaymentsPayerExperienceRoute
  '/payments/retry-analysis': typeof PaymentsRetryAnalysisRoute
  '/payments/retry-analysis-tsys': typeof PaymentsRetryAnalysisTsysRoute
  '/platform/displays': typeof PlatformDisplaysRoute
  '/platform/jobs': typeof PlatformJobsRoute
  '/product/ai-texts': typeof ProductAiTextsRoute
  '/product/decline-payment-journey': typeof ProductDeclinePaymentJourneyRoute
  '/product/request-triage': typeof ProductRequestTriageRoute
  '/product/requests': typeof ProductRequestsRoute
  '/risk/chargeback-disputes': typeof RiskChargebackDisputesRoute
  '/risk/chargebacks-by-origin': typeof RiskChargebacksByOriginRoute
  '/risk/chargebacks-overview': typeof RiskChargebacksOverviewRoute
  '/risk/decline-by-mid': typeof RiskDeclineByMidRoute
  '/risk/decline-retries': typeof RiskDeclineRetriesRoute
  '/risk/declines': typeof RiskDeclinesRoute
  '/risk/merchant-outliers': typeof RiskMerchantOutliersRoute
  '/risk/merchant-profile': typeof RiskMerchantProfileRoute
  '/risk/merchant-risk': typeof RiskMerchantRiskRoute
  '/risk/portfolio-risk-kpis': typeof RiskPortfolioRiskKpisRoute
  '/risk/transaction-scoring': typeof RiskTransactionScoringRoute
  '/sales-tools/pricing-studio': typeof SalesToolsPricingStudioRoute
  '/sales/activity': typeof SalesActivityRoute
  '/sales/book-onboarding': typeof SalesBookOnboardingRoute
  '/sales/pipeline': typeof SalesPipelineRoute
  '/sales/scorecard': typeof SalesScorecardRoute
  '/sales/win-loss': typeof SalesWinLossRoute
  '/studio/dashboard': typeof StudioDashboardRoute
  '/studio/deck': typeof StudioDeckRoute
  '/studio/library': typeof StudioLibraryRoute
  '/studio/report': typeof StudioReportRoute
  '/studio/tv': typeof StudioTvRoute
  '/transaction-monitoring/duplicate-ach': typeof TransactionMonitoringDuplicateAchRoute
  '/transaction-monitoring/duplicate-cards': typeof TransactionMonitoringDuplicateCardsRoute
  '/transaction-monitoring/duplicate-payments': typeof TransactionMonitoringDuplicatePaymentsRoute
  '/transaction-monitoring/high-low-tickets': typeof TransactionMonitoringHighLowTicketsRoute
  '/transaction-monitoring/owner-payments': typeof TransactionMonitoringOwnerPaymentsRoute
  '/transaction-monitoring/repeat-card-usage': typeof TransactionMonitoringRepeatCardUsageRoute
  '/transaction-monitoring/same-day-repeats': typeof TransactionMonitoringSameDayRepeatsRoute
  '/platform/displays_/$name': typeof PlatformDisplaysNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/display-video'
    | '/ach/daily'
    | '/ach/merchant-rejections'
    | '/ach/nacha-rates'
    | '/ach/reason-codes'
    | '/ach/return-reasons'
    | '/ach/returns'
    | '/ach/trends'
    | '/ach/volume-trends'
    | '/alerts/rules'
    | '/business-performance/client-scorecard'
    | '/business-performance/dms-volume'
    | '/business-performance/feature-adoption'
    | '/business-performance/go-live-ramp-up'
    | '/business-performance/merchant-weekly-tiers'
    | '/business-performance/payment-origin'
    | '/business-performance/platform-activity'
    | '/business-performance/tpv-tcv-peaks'
    | '/business-performance/weekly-trends'
    | '/collections/account-delinquency'
    | '/collections/ai-decline-impact'
    | '/collections/ai-decline-journeys'
    | '/collections/blytzcollect-analytics'
    | '/collections/propensity-accuracy'
    | '/collections/propensity-to-pay'
    | '/collections/scorecard'
    | '/company/tv-board'
    | '/cs-tools/account-change-log'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/customer-list'
    | '/cs-tools/follow-up-report'
    | '/cs-tools/inbound-messages'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/merchant-users'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-out-sources'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-origin-share'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/twilio-replies'
    | '/cs-tools/undelivered'
    | '/display/$name'
    | '/engineering/agent-board'
    | '/engineering/service-performance'
    | '/engineering/unanswered-questions'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/merchants/hubspot-sync'
    | '/merchants/location-lookup'
    | '/merchants/locations'
    | '/merchants/master-list'
    | '/merchants/merchant-360'
    | '/merchants/merchant-settings'
    | '/merchants/mmpv'
    | '/merchants/onboarding-pipeline'
    | '/merchants/portfolio-callouts'
    | '/merchants/processors'
    | '/merchants/rewind'
    | '/payments/ai-decline-codes'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/payer-experience'
    | '/payments/retry-analysis'
    | '/payments/retry-analysis-tsys'
    | '/platform/displays'
    | '/platform/jobs'
    | '/product/ai-texts'
    | '/product/decline-payment-journey'
    | '/product/request-triage'
    | '/product/requests'
    | '/risk/chargeback-disputes'
    | '/risk/chargebacks-by-origin'
    | '/risk/chargebacks-overview'
    | '/risk/decline-by-mid'
    | '/risk/decline-retries'
    | '/risk/declines'
    | '/risk/merchant-outliers'
    | '/risk/merchant-profile'
    | '/risk/merchant-risk'
    | '/risk/portfolio-risk-kpis'
    | '/risk/transaction-scoring'
    | '/sales-tools/pricing-studio'
    | '/sales/activity'
    | '/sales/book-onboarding'
    | '/sales/pipeline'
    | '/sales/scorecard'
    | '/sales/win-loss'
    | '/studio/dashboard'
    | '/studio/deck'
    | '/studio/library'
    | '/studio/report'
    | '/studio/tv'
    | '/transaction-monitoring/duplicate-ach'
    | '/transaction-monitoring/duplicate-cards'
    | '/transaction-monitoring/duplicate-payments'
    | '/transaction-monitoring/high-low-tickets'
    | '/transaction-monitoring/owner-payments'
    | '/transaction-monitoring/repeat-card-usage'
    | '/transaction-monitoring/same-day-repeats'
    | '/platform/displays/$name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/display-video'
    | '/ach/daily'
    | '/ach/merchant-rejections'
    | '/ach/nacha-rates'
    | '/ach/reason-codes'
    | '/ach/return-reasons'
    | '/ach/returns'
    | '/ach/trends'
    | '/ach/volume-trends'
    | '/alerts/rules'
    | '/business-performance/client-scorecard'
    | '/business-performance/dms-volume'
    | '/business-performance/feature-adoption'
    | '/business-performance/go-live-ramp-up'
    | '/business-performance/merchant-weekly-tiers'
    | '/business-performance/payment-origin'
    | '/business-performance/platform-activity'
    | '/business-performance/tpv-tcv-peaks'
    | '/business-performance/weekly-trends'
    | '/collections/account-delinquency'
    | '/collections/ai-decline-impact'
    | '/collections/ai-decline-journeys'
    | '/collections/blytzcollect-analytics'
    | '/collections/propensity-accuracy'
    | '/collections/propensity-to-pay'
    | '/collections/scorecard'
    | '/company/tv-board'
    | '/cs-tools/account-change-log'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/customer-list'
    | '/cs-tools/follow-up-report'
    | '/cs-tools/inbound-messages'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/merchant-users'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-out-sources'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-origin-share'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/twilio-replies'
    | '/cs-tools/undelivered'
    | '/display/$name'
    | '/engineering/agent-board'
    | '/engineering/service-performance'
    | '/engineering/unanswered-questions'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/merchants/hubspot-sync'
    | '/merchants/location-lookup'
    | '/merchants/locations'
    | '/merchants/master-list'
    | '/merchants/merchant-360'
    | '/merchants/merchant-settings'
    | '/merchants/mmpv'
    | '/merchants/onboarding-pipeline'
    | '/merchants/portfolio-callouts'
    | '/merchants/processors'
    | '/merchants/rewind'
    | '/payments/ai-decline-codes'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/payer-experience'
    | '/payments/retry-analysis'
    | '/payments/retry-analysis-tsys'
    | '/platform/displays'
    | '/platform/jobs'
    | '/product/ai-texts'
    | '/product/decline-payment-journey'
    | '/product/request-triage'
    | '/product/requests'
    | '/risk/chargeback-disputes'
    | '/risk/chargebacks-by-origin'
    | '/risk/chargebacks-overview'
    | '/risk/decline-by-mid'
    | '/risk/decline-retries'
    | '/risk/declines'
    | '/risk/merchant-outliers'
    | '/risk/merchant-profile'
    | '/risk/merchant-risk'
    | '/risk/portfolio-risk-kpis'
    | '/risk/transaction-scoring'
    | '/sales-tools/pricing-studio'
    | '/sales/activity'
    | '/sales/book-onboarding'
    | '/sales/pipeline'
    | '/sales/scorecard'
    | '/sales/win-loss'
    | '/studio/dashboard'
    | '/studio/deck'
    | '/studio/library'
    | '/studio/report'
    | '/studio/tv'
    | '/transaction-monitoring/duplicate-ach'
    | '/transaction-monitoring/duplicate-cards'
    | '/transaction-monitoring/duplicate-payments'
    | '/transaction-monitoring/high-low-tickets'
    | '/transaction-monitoring/owner-payments'
    | '/transaction-monitoring/repeat-card-usage'
    | '/transaction-monitoring/same-day-repeats'
    | '/platform/displays/$name'
  id:
    | '__root__'
    | '/'
    | '/display-video'
    | '/ach/daily'
    | '/ach/merchant-rejections'
    | '/ach/nacha-rates'
    | '/ach/reason-codes'
    | '/ach/return-reasons'
    | '/ach/returns'
    | '/ach/trends'
    | '/ach/volume-trends'
    | '/alerts/rules'
    | '/business-performance/client-scorecard'
    | '/business-performance/dms-volume'
    | '/business-performance/feature-adoption'
    | '/business-performance/go-live-ramp-up'
    | '/business-performance/merchant-weekly-tiers'
    | '/business-performance/payment-origin'
    | '/business-performance/platform-activity'
    | '/business-performance/tpv-tcv-peaks'
    | '/business-performance/weekly-trends'
    | '/collections/account-delinquency'
    | '/collections/ai-decline-impact'
    | '/collections/ai-decline-journeys'
    | '/collections/blytzcollect-analytics'
    | '/collections/propensity-accuracy'
    | '/collections/propensity-to-pay'
    | '/collections/scorecard'
    | '/company/tv-board'
    | '/cs-tools/account-change-log'
    | '/cs-tools/autopay-accounts'
    | '/cs-tools/customer-list'
    | '/cs-tools/follow-up-report'
    | '/cs-tools/inbound-messages'
    | '/cs-tools/merchant-notes'
    | '/cs-tools/merchant-users'
    | '/cs-tools/message-report'
    | '/cs-tools/opt-out-sources'
    | '/cs-tools/opt-outs'
    | '/cs-tools/payment-origin-share'
    | '/cs-tools/payment-report'
    | '/cs-tools/reconciliation'
    | '/cs-tools/registrations'
    | '/cs-tools/twilio-replies'
    | '/cs-tools/undelivered'
    | '/display/$name'
    | '/engineering/agent-board'
    | '/engineering/service-performance'
    | '/engineering/unanswered-questions'
    | '/lab/report-chat'
    | '/lab/report-draft'
    | '/lab/report-drafts'
    | '/merchants/hubspot-sync'
    | '/merchants/location-lookup'
    | '/merchants/locations'
    | '/merchants/master-list'
    | '/merchants/merchant-360'
    | '/merchants/merchant-settings'
    | '/merchants/mmpv'
    | '/merchants/onboarding-pipeline'
    | '/merchants/portfolio-callouts'
    | '/merchants/processors'
    | '/merchants/rewind'
    | '/payments/ai-decline-codes'
    | '/payments/bin-mcc-fee-report'
    | '/payments/multicard-usage'
    | '/payments/payer-experience'
    | '/payments/retry-analysis'
    | '/payments/retry-analysis-tsys'
    | '/platform/displays'
    | '/platform/jobs'
    | '/product/ai-texts'
    | '/product/decline-payment-journey'
    | '/product/request-triage'
    | '/product/requests'
    | '/risk/chargeback-disputes'
    | '/risk/chargebacks-by-origin'
    | '/risk/chargebacks-overview'
    | '/risk/decline-by-mid'
    | '/risk/decline-retries'
    | '/risk/declines'
    | '/risk/merchant-outliers'
    | '/risk/merchant-profile'
    | '/risk/merchant-risk'
    | '/risk/portfolio-risk-kpis'
    | '/risk/transaction-scoring'
    | '/sales-tools/pricing-studio'
    | '/sales/activity'
    | '/sales/book-onboarding'
    | '/sales/pipeline'
    | '/sales/scorecard'
    | '/sales/win-loss'
    | '/studio/dashboard'
    | '/studio/deck'
    | '/studio/library'
    | '/studio/report'
    | '/studio/tv'
    | '/transaction-monitoring/duplicate-ach'
    | '/transaction-monitoring/duplicate-cards'
    | '/transaction-monitoring/duplicate-payments'
    | '/transaction-monitoring/high-low-tickets'
    | '/transaction-monitoring/owner-payments'
    | '/transaction-monitoring/repeat-card-usage'
    | '/transaction-monitoring/same-day-repeats'
    | '/platform/displays_/$name'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DisplayVideoRoute: typeof DisplayVideoRoute
  AchDailyRoute: typeof AchDailyRoute
  AchMerchantRejectionsRoute: typeof AchMerchantRejectionsRoute
  AchNachaRatesRoute: typeof AchNachaRatesRoute
  AchReasonCodesRoute: typeof AchReasonCodesRoute
  AchReturnReasonsRoute: typeof AchReturnReasonsRoute
  AchReturnsRoute: typeof AchReturnsRoute
  AchTrendsRoute: typeof AchTrendsRoute
  AchVolumeTrendsRoute: typeof AchVolumeTrendsRoute
  AlertsRulesRoute: typeof AlertsRulesRoute
  BusinessPerformanceClientScorecardRoute: typeof BusinessPerformanceClientScorecardRoute
  BusinessPerformanceDmsVolumeRoute: typeof BusinessPerformanceDmsVolumeRoute
  BusinessPerformanceFeatureAdoptionRoute: typeof BusinessPerformanceFeatureAdoptionRoute
  BusinessPerformanceGoLiveRampUpRoute: typeof BusinessPerformanceGoLiveRampUpRoute
  BusinessPerformanceMerchantWeeklyTiersRoute: typeof BusinessPerformanceMerchantWeeklyTiersRoute
  BusinessPerformancePaymentOriginRoute: typeof BusinessPerformancePaymentOriginRoute
  BusinessPerformancePlatformActivityRoute: typeof BusinessPerformancePlatformActivityRoute
  BusinessPerformanceTpvTcvPeaksRoute: typeof BusinessPerformanceTpvTcvPeaksRoute
  BusinessPerformanceWeeklyTrendsRoute: typeof BusinessPerformanceWeeklyTrendsRoute
  CollectionsAccountDelinquencyRoute: typeof CollectionsAccountDelinquencyRoute
  CollectionsAiDeclineImpactRoute: typeof CollectionsAiDeclineImpactRoute
  CollectionsAiDeclineJourneysRoute: typeof CollectionsAiDeclineJourneysRoute
  CollectionsBlytzcollectAnalyticsRoute: typeof CollectionsBlytzcollectAnalyticsRoute
  CollectionsPropensityAccuracyRoute: typeof CollectionsPropensityAccuracyRoute
  CollectionsPropensityToPayRoute: typeof CollectionsPropensityToPayRoute
  CollectionsScorecardRoute: typeof CollectionsScorecardRoute
  CompanyTvBoardRoute: typeof CompanyTvBoardRoute
  CsToolsAccountChangeLogRoute: typeof CsToolsAccountChangeLogRoute
  CsToolsAutopayAccountsRoute: typeof CsToolsAutopayAccountsRoute
  CsToolsCustomerListRoute: typeof CsToolsCustomerListRoute
  CsToolsFollowUpReportRoute: typeof CsToolsFollowUpReportRoute
  CsToolsInboundMessagesRoute: typeof CsToolsInboundMessagesRoute
  CsToolsMerchantNotesRoute: typeof CsToolsMerchantNotesRoute
  CsToolsMerchantUsersRoute: typeof CsToolsMerchantUsersRoute
  CsToolsMessageReportRoute: typeof CsToolsMessageReportRoute
  CsToolsOptOutSourcesRoute: typeof CsToolsOptOutSourcesRoute
  CsToolsOptOutsRoute: typeof CsToolsOptOutsRoute
  CsToolsPaymentOriginShareRoute: typeof CsToolsPaymentOriginShareRoute
  CsToolsPaymentReportRoute: typeof CsToolsPaymentReportRoute
  CsToolsReconciliationRoute: typeof CsToolsReconciliationRoute
  CsToolsRegistrationsRoute: typeof CsToolsRegistrationsRoute
  CsToolsTwilioRepliesRoute: typeof CsToolsTwilioRepliesRoute
  CsToolsUndeliveredRoute: typeof CsToolsUndeliveredRoute
  DisplayNameRoute: typeof DisplayNameRoute
  EngineeringAgentBoardRoute: typeof EngineeringAgentBoardRoute
  EngineeringServicePerformanceRoute: typeof EngineeringServicePerformanceRoute
  EngineeringUnansweredQuestionsRoute: typeof EngineeringUnansweredQuestionsRoute
  LabReportChatRoute: typeof LabReportChatRoute
  LabReportDraftRoute: typeof LabReportDraftRoute
  LabReportDraftsRoute: typeof LabReportDraftsRoute
  MerchantsHubspotSyncRoute: typeof MerchantsHubspotSyncRoute
  MerchantsLocationLookupRoute: typeof MerchantsLocationLookupRoute
  MerchantsLocationsRoute: typeof MerchantsLocationsRoute
  MerchantsMasterListRoute: typeof MerchantsMasterListRoute
  MerchantsMerchant360Route: typeof MerchantsMerchant360Route
  MerchantsMerchantSettingsRoute: typeof MerchantsMerchantSettingsRoute
  MerchantsMmpvRoute: typeof MerchantsMmpvRoute
  MerchantsOnboardingPipelineRoute: typeof MerchantsOnboardingPipelineRoute
  MerchantsPortfolioCalloutsRoute: typeof MerchantsPortfolioCalloutsRoute
  MerchantsProcessorsRoute: typeof MerchantsProcessorsRoute
  MerchantsRewindRoute: typeof MerchantsRewindRoute
  PaymentsAiDeclineCodesRoute: typeof PaymentsAiDeclineCodesRoute
  PaymentsBinMccFeeReportRoute: typeof PaymentsBinMccFeeReportRoute
  PaymentsMulticardUsageRoute: typeof PaymentsMulticardUsageRoute
  PaymentsPayerExperienceRoute: typeof PaymentsPayerExperienceRoute
  PaymentsRetryAnalysisRoute: typeof PaymentsRetryAnalysisRoute
  PaymentsRetryAnalysisTsysRoute: typeof PaymentsRetryAnalysisTsysRoute
  PlatformDisplaysRoute: typeof PlatformDisplaysRoute
  PlatformJobsRoute: typeof PlatformJobsRoute
  ProductAiTextsRoute: typeof ProductAiTextsRoute
  ProductDeclinePaymentJourneyRoute: typeof ProductDeclinePaymentJourneyRoute
  ProductRequestTriageRoute: typeof ProductRequestTriageRoute
  ProductRequestsRoute: typeof ProductRequestsRoute
  RiskChargebackDisputesRoute: typeof RiskChargebackDisputesRoute
  RiskChargebacksByOriginRoute: typeof RiskChargebacksByOriginRoute
  RiskChargebacksOverviewRoute: typeof RiskChargebacksOverviewRoute
  RiskDeclineByMidRoute: typeof RiskDeclineByMidRoute
  RiskDeclineRetriesRoute: typeof RiskDeclineRetriesRoute
  RiskDeclinesRoute: typeof RiskDeclinesRoute
  RiskMerchantOutliersRoute: typeof RiskMerchantOutliersRoute
  RiskMerchantProfileRoute: typeof RiskMerchantProfileRoute
  RiskMerchantRiskRoute: typeof RiskMerchantRiskRoute
  RiskPortfolioRiskKpisRoute: typeof RiskPortfolioRiskKpisRoute
  RiskTransactionScoringRoute: typeof RiskTransactionScoringRoute
  SalesToolsPricingStudioRoute: typeof SalesToolsPricingStudioRoute
  SalesActivityRoute: typeof SalesActivityRoute
  SalesBookOnboardingRoute: typeof SalesBookOnboardingRoute
  SalesPipelineRoute: typeof SalesPipelineRoute
  SalesScorecardRoute: typeof SalesScorecardRoute
  SalesWinLossRoute: typeof SalesWinLossRoute
  StudioDashboardRoute: typeof StudioDashboardRoute
  StudioDeckRoute: typeof StudioDeckRoute
  StudioLibraryRoute: typeof StudioLibraryRoute
  StudioReportRoute: typeof StudioReportRoute
  StudioTvRoute: typeof StudioTvRoute
  TransactionMonitoringDuplicateAchRoute: typeof TransactionMonitoringDuplicateAchRoute
  TransactionMonitoringDuplicateCardsRoute: typeof TransactionMonitoringDuplicateCardsRoute
  TransactionMonitoringDuplicatePaymentsRoute: typeof TransactionMonitoringDuplicatePaymentsRoute
  TransactionMonitoringHighLowTicketsRoute: typeof TransactionMonitoringHighLowTicketsRoute
  TransactionMonitoringOwnerPaymentsRoute: typeof TransactionMonitoringOwnerPaymentsRoute
  TransactionMonitoringRepeatCardUsageRoute: typeof TransactionMonitoringRepeatCardUsageRoute
  TransactionMonitoringSameDayRepeatsRoute: typeof TransactionMonitoringSameDayRepeatsRoute
  PlatformDisplaysNameRoute: typeof PlatformDisplaysNameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display-video': {
      id: '/display-video'
      path: '/display-video'
      fullPath: '/display-video'
      preLoaderRoute: typeof DisplayVideoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/daily': {
      id: '/ach/daily'
      path: '/ach/daily'
      fullPath: '/ach/daily'
      preLoaderRoute: typeof AchDailyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/merchant-rejections': {
      id: '/ach/merchant-rejections'
      path: '/ach/merchant-rejections'
      fullPath: '/ach/merchant-rejections'
      preLoaderRoute: typeof AchMerchantRejectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/nacha-rates': {
      id: '/ach/nacha-rates'
      path: '/ach/nacha-rates'
      fullPath: '/ach/nacha-rates'
      preLoaderRoute: typeof AchNachaRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/reason-codes': {
      id: '/ach/reason-codes'
      path: '/ach/reason-codes'
      fullPath: '/ach/reason-codes'
      preLoaderRoute: typeof AchReasonCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/return-reasons': {
      id: '/ach/return-reasons'
      path: '/ach/return-reasons'
      fullPath: '/ach/return-reasons'
      preLoaderRoute: typeof AchReturnReasonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/returns': {
      id: '/ach/returns'
      path: '/ach/returns'
      fullPath: '/ach/returns'
      preLoaderRoute: typeof AchReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/trends': {
      id: '/ach/trends'
      path: '/ach/trends'
      fullPath: '/ach/trends'
      preLoaderRoute: typeof AchTrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ach/volume-trends': {
      id: '/ach/volume-trends'
      path: '/ach/volume-trends'
      fullPath: '/ach/volume-trends'
      preLoaderRoute: typeof AchVolumeTrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/rules': {
      id: '/alerts/rules'
      path: '/alerts/rules'
      fullPath: '/alerts/rules'
      preLoaderRoute: typeof AlertsRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/client-scorecard': {
      id: '/business-performance/client-scorecard'
      path: '/business-performance/client-scorecard'
      fullPath: '/business-performance/client-scorecard'
      preLoaderRoute: typeof BusinessPerformanceClientScorecardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/dms-volume': {
      id: '/business-performance/dms-volume'
      path: '/business-performance/dms-volume'
      fullPath: '/business-performance/dms-volume'
      preLoaderRoute: typeof BusinessPerformanceDmsVolumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/feature-adoption': {
      id: '/business-performance/feature-adoption'
      path: '/business-performance/feature-adoption'
      fullPath: '/business-performance/feature-adoption'
      preLoaderRoute: typeof BusinessPerformanceFeatureAdoptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/go-live-ramp-up': {
      id: '/business-performance/go-live-ramp-up'
      path: '/business-performance/go-live-ramp-up'
      fullPath: '/business-performance/go-live-ramp-up'
      preLoaderRoute: typeof BusinessPerformanceGoLiveRampUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/merchant-weekly-tiers': {
      id: '/business-performance/merchant-weekly-tiers'
      path: '/business-performance/merchant-weekly-tiers'
      fullPath: '/business-performance/merchant-weekly-tiers'
      preLoaderRoute: typeof BusinessPerformanceMerchantWeeklyTiersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/payment-origin': {
      id: '/business-performance/payment-origin'
      path: '/business-performance/payment-origin'
      fullPath: '/business-performance/payment-origin'
      preLoaderRoute: typeof BusinessPerformancePaymentOriginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/platform-activity': {
      id: '/business-performance/platform-activity'
      path: '/business-performance/platform-activity'
      fullPath: '/business-performance/platform-activity'
      preLoaderRoute: typeof BusinessPerformancePlatformActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/tpv-tcv-peaks': {
      id: '/business-performance/tpv-tcv-peaks'
      path: '/business-performance/tpv-tcv-peaks'
      fullPath: '/business-performance/tpv-tcv-peaks'
      preLoaderRoute: typeof BusinessPerformanceTpvTcvPeaksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business-performance/weekly-trends': {
      id: '/business-performance/weekly-trends'
      path: '/business-performance/weekly-trends'
      fullPath: '/business-performance/weekly-trends'
      preLoaderRoute: typeof BusinessPerformanceWeeklyTrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/account-delinquency': {
      id: '/collections/account-delinquency'
      path: '/collections/account-delinquency'
      fullPath: '/collections/account-delinquency'
      preLoaderRoute: typeof CollectionsAccountDelinquencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/ai-decline-impact': {
      id: '/collections/ai-decline-impact'
      path: '/collections/ai-decline-impact'
      fullPath: '/collections/ai-decline-impact'
      preLoaderRoute: typeof CollectionsAiDeclineImpactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/ai-decline-journeys': {
      id: '/collections/ai-decline-journeys'
      path: '/collections/ai-decline-journeys'
      fullPath: '/collections/ai-decline-journeys'
      preLoaderRoute: typeof CollectionsAiDeclineJourneysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/blytzcollect-analytics': {
      id: '/collections/blytzcollect-analytics'
      path: '/collections/blytzcollect-analytics'
      fullPath: '/collections/blytzcollect-analytics'
      preLoaderRoute: typeof CollectionsBlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/propensity-accuracy': {
      id: '/collections/propensity-accuracy'
      path: '/collections/propensity-accuracy'
      fullPath: '/collections/propensity-accuracy'
      preLoaderRoute: typeof CollectionsPropensityAccuracyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/propensity-to-pay': {
      id: '/collections/propensity-to-pay'
      path: '/collections/propensity-to-pay'
      fullPath: '/collections/propensity-to-pay'
      preLoaderRoute: typeof CollectionsPropensityToPayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/scorecard': {
      id: '/collections/scorecard'
      path: '/collections/scorecard'
      fullPath: '/collections/scorecard'
      preLoaderRoute: typeof CollectionsScorecardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company/tv-board': {
      id: '/company/tv-board'
      path: '/company/tv-board'
      fullPath: '/company/tv-board'
      preLoaderRoute: typeof CompanyTvBoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/account-change-log': {
      id: '/cs-tools/account-change-log'
      path: '/cs-tools/account-change-log'
      fullPath: '/cs-tools/account-change-log'
      preLoaderRoute: typeof CsToolsAccountChangeLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/autopay-accounts': {
      id: '/cs-tools/autopay-accounts'
      path: '/cs-tools/autopay-accounts'
      fullPath: '/cs-tools/autopay-accounts'
      preLoaderRoute: typeof CsToolsAutopayAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/customer-list': {
      id: '/cs-tools/customer-list'
      path: '/cs-tools/customer-list'
      fullPath: '/cs-tools/customer-list'
      preLoaderRoute: typeof CsToolsCustomerListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/follow-up-report': {
      id: '/cs-tools/follow-up-report'
      path: '/cs-tools/follow-up-report'
      fullPath: '/cs-tools/follow-up-report'
      preLoaderRoute: typeof CsToolsFollowUpReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/inbound-messages': {
      id: '/cs-tools/inbound-messages'
      path: '/cs-tools/inbound-messages'
      fullPath: '/cs-tools/inbound-messages'
      preLoaderRoute: typeof CsToolsInboundMessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/merchant-notes': {
      id: '/cs-tools/merchant-notes'
      path: '/cs-tools/merchant-notes'
      fullPath: '/cs-tools/merchant-notes'
      preLoaderRoute: typeof CsToolsMerchantNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/merchant-users': {
      id: '/cs-tools/merchant-users'
      path: '/cs-tools/merchant-users'
      fullPath: '/cs-tools/merchant-users'
      preLoaderRoute: typeof CsToolsMerchantUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/message-report': {
      id: '/cs-tools/message-report'
      path: '/cs-tools/message-report'
      fullPath: '/cs-tools/message-report'
      preLoaderRoute: typeof CsToolsMessageReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/opt-out-sources': {
      id: '/cs-tools/opt-out-sources'
      path: '/cs-tools/opt-out-sources'
      fullPath: '/cs-tools/opt-out-sources'
      preLoaderRoute: typeof CsToolsOptOutSourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/opt-outs': {
      id: '/cs-tools/opt-outs'
      path: '/cs-tools/opt-outs'
      fullPath: '/cs-tools/opt-outs'
      preLoaderRoute: typeof CsToolsOptOutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/payment-origin-share': {
      id: '/cs-tools/payment-origin-share'
      path: '/cs-tools/payment-origin-share'
      fullPath: '/cs-tools/payment-origin-share'
      preLoaderRoute: typeof CsToolsPaymentOriginShareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/payment-report': {
      id: '/cs-tools/payment-report'
      path: '/cs-tools/payment-report'
      fullPath: '/cs-tools/payment-report'
      preLoaderRoute: typeof CsToolsPaymentReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/reconciliation': {
      id: '/cs-tools/reconciliation'
      path: '/cs-tools/reconciliation'
      fullPath: '/cs-tools/reconciliation'
      preLoaderRoute: typeof CsToolsReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/registrations': {
      id: '/cs-tools/registrations'
      path: '/cs-tools/registrations'
      fullPath: '/cs-tools/registrations'
      preLoaderRoute: typeof CsToolsRegistrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/twilio-replies': {
      id: '/cs-tools/twilio-replies'
      path: '/cs-tools/twilio-replies'
      fullPath: '/cs-tools/twilio-replies'
      preLoaderRoute: typeof CsToolsTwilioRepliesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/undelivered': {
      id: '/cs-tools/undelivered'
      path: '/cs-tools/undelivered'
      fullPath: '/cs-tools/undelivered'
      preLoaderRoute: typeof CsToolsUndeliveredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display/$name': {
      id: '/display/$name'
      path: '/display/$name'
      fullPath: '/display/$name'
      preLoaderRoute: typeof DisplayNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engineering/agent-board': {
      id: '/engineering/agent-board'
      path: '/engineering/agent-board'
      fullPath: '/engineering/agent-board'
      preLoaderRoute: typeof EngineeringAgentBoardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engineering/service-performance': {
      id: '/engineering/service-performance'
      path: '/engineering/service-performance'
      fullPath: '/engineering/service-performance'
      preLoaderRoute: typeof EngineeringServicePerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engineering/unanswered-questions': {
      id: '/engineering/unanswered-questions'
      path: '/engineering/unanswered-questions'
      fullPath: '/engineering/unanswered-questions'
      preLoaderRoute: typeof EngineeringUnansweredQuestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-chat': {
      id: '/lab/report-chat'
      path: '/lab/report-chat'
      fullPath: '/lab/report-chat'
      preLoaderRoute: typeof LabReportChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-draft': {
      id: '/lab/report-draft'
      path: '/lab/report-draft'
      fullPath: '/lab/report-draft'
      preLoaderRoute: typeof LabReportDraftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/report-drafts': {
      id: '/lab/report-drafts'
      path: '/lab/report-drafts'
      fullPath: '/lab/report-drafts'
      preLoaderRoute: typeof LabReportDraftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/hubspot-sync': {
      id: '/merchants/hubspot-sync'
      path: '/merchants/hubspot-sync'
      fullPath: '/merchants/hubspot-sync'
      preLoaderRoute: typeof MerchantsHubspotSyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/location-lookup': {
      id: '/merchants/location-lookup'
      path: '/merchants/location-lookup'
      fullPath: '/merchants/location-lookup'
      preLoaderRoute: typeof MerchantsLocationLookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/locations': {
      id: '/merchants/locations'
      path: '/merchants/locations'
      fullPath: '/merchants/locations'
      preLoaderRoute: typeof MerchantsLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/master-list': {
      id: '/merchants/master-list'
      path: '/merchants/master-list'
      fullPath: '/merchants/master-list'
      preLoaderRoute: typeof MerchantsMasterListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/merchant-360': {
      id: '/merchants/merchant-360'
      path: '/merchants/merchant-360'
      fullPath: '/merchants/merchant-360'
      preLoaderRoute: typeof MerchantsMerchant360RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/merchant-settings': {
      id: '/merchants/merchant-settings'
      path: '/merchants/merchant-settings'
      fullPath: '/merchants/merchant-settings'
      preLoaderRoute: typeof MerchantsMerchantSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/mmpv': {
      id: '/merchants/mmpv'
      path: '/merchants/mmpv'
      fullPath: '/merchants/mmpv'
      preLoaderRoute: typeof MerchantsMmpvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/onboarding-pipeline': {
      id: '/merchants/onboarding-pipeline'
      path: '/merchants/onboarding-pipeline'
      fullPath: '/merchants/onboarding-pipeline'
      preLoaderRoute: typeof MerchantsOnboardingPipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/portfolio-callouts': {
      id: '/merchants/portfolio-callouts'
      path: '/merchants/portfolio-callouts'
      fullPath: '/merchants/portfolio-callouts'
      preLoaderRoute: typeof MerchantsPortfolioCalloutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/processors': {
      id: '/merchants/processors'
      path: '/merchants/processors'
      fullPath: '/merchants/processors'
      preLoaderRoute: typeof MerchantsProcessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/rewind': {
      id: '/merchants/rewind'
      path: '/merchants/rewind'
      fullPath: '/merchants/rewind'
      preLoaderRoute: typeof MerchantsRewindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/ai-decline-codes': {
      id: '/payments/ai-decline-codes'
      path: '/payments/ai-decline-codes'
      fullPath: '/payments/ai-decline-codes'
      preLoaderRoute: typeof PaymentsAiDeclineCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/bin-mcc-fee-report': {
      id: '/payments/bin-mcc-fee-report'
      path: '/payments/bin-mcc-fee-report'
      fullPath: '/payments/bin-mcc-fee-report'
      preLoaderRoute: typeof PaymentsBinMccFeeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/multicard-usage': {
      id: '/payments/multicard-usage'
      path: '/payments/multicard-usage'
      fullPath: '/payments/multicard-usage'
      preLoaderRoute: typeof PaymentsMulticardUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/payer-experience': {
      id: '/payments/payer-experience'
      path: '/payments/payer-experience'
      fullPath: '/payments/payer-experience'
      preLoaderRoute: typeof PaymentsPayerExperienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/retry-analysis': {
      id: '/payments/retry-analysis'
      path: '/payments/retry-analysis'
      fullPath: '/payments/retry-analysis'
      preLoaderRoute: typeof PaymentsRetryAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/retry-analysis-tsys': {
      id: '/payments/retry-analysis-tsys'
      path: '/payments/retry-analysis-tsys'
      fullPath: '/payments/retry-analysis-tsys'
      preLoaderRoute: typeof PaymentsRetryAnalysisTsysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/displays': {
      id: '/platform/displays'
      path: '/platform/displays'
      fullPath: '/platform/displays'
      preLoaderRoute: typeof PlatformDisplaysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/jobs': {
      id: '/platform/jobs'
      path: '/platform/jobs'
      fullPath: '/platform/jobs'
      preLoaderRoute: typeof PlatformJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/ai-texts': {
      id: '/product/ai-texts'
      path: '/product/ai-texts'
      fullPath: '/product/ai-texts'
      preLoaderRoute: typeof ProductAiTextsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/decline-payment-journey': {
      id: '/product/decline-payment-journey'
      path: '/product/decline-payment-journey'
      fullPath: '/product/decline-payment-journey'
      preLoaderRoute: typeof ProductDeclinePaymentJourneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/request-triage': {
      id: '/product/request-triage'
      path: '/product/request-triage'
      fullPath: '/product/request-triage'
      preLoaderRoute: typeof ProductRequestTriageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/requests': {
      id: '/product/requests'
      path: '/product/requests'
      fullPath: '/product/requests'
      preLoaderRoute: typeof ProductRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/chargeback-disputes': {
      id: '/risk/chargeback-disputes'
      path: '/risk/chargeback-disputes'
      fullPath: '/risk/chargeback-disputes'
      preLoaderRoute: typeof RiskChargebackDisputesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/chargebacks-by-origin': {
      id: '/risk/chargebacks-by-origin'
      path: '/risk/chargebacks-by-origin'
      fullPath: '/risk/chargebacks-by-origin'
      preLoaderRoute: typeof RiskChargebacksByOriginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/chargebacks-overview': {
      id: '/risk/chargebacks-overview'
      path: '/risk/chargebacks-overview'
      fullPath: '/risk/chargebacks-overview'
      preLoaderRoute: typeof RiskChargebacksOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/decline-by-mid': {
      id: '/risk/decline-by-mid'
      path: '/risk/decline-by-mid'
      fullPath: '/risk/decline-by-mid'
      preLoaderRoute: typeof RiskDeclineByMidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/decline-retries': {
      id: '/risk/decline-retries'
      path: '/risk/decline-retries'
      fullPath: '/risk/decline-retries'
      preLoaderRoute: typeof RiskDeclineRetriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/declines': {
      id: '/risk/declines'
      path: '/risk/declines'
      fullPath: '/risk/declines'
      preLoaderRoute: typeof RiskDeclinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/merchant-outliers': {
      id: '/risk/merchant-outliers'
      path: '/risk/merchant-outliers'
      fullPath: '/risk/merchant-outliers'
      preLoaderRoute: typeof RiskMerchantOutliersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/merchant-profile': {
      id: '/risk/merchant-profile'
      path: '/risk/merchant-profile'
      fullPath: '/risk/merchant-profile'
      preLoaderRoute: typeof RiskMerchantProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/merchant-risk': {
      id: '/risk/merchant-risk'
      path: '/risk/merchant-risk'
      fullPath: '/risk/merchant-risk'
      preLoaderRoute: typeof RiskMerchantRiskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/portfolio-risk-kpis': {
      id: '/risk/portfolio-risk-kpis'
      path: '/risk/portfolio-risk-kpis'
      fullPath: '/risk/portfolio-risk-kpis'
      preLoaderRoute: typeof RiskPortfolioRiskKpisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk/transaction-scoring': {
      id: '/risk/transaction-scoring'
      path: '/risk/transaction-scoring'
      fullPath: '/risk/transaction-scoring'
      preLoaderRoute: typeof RiskTransactionScoringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-tools/pricing-studio': {
      id: '/sales-tools/pricing-studio'
      path: '/sales-tools/pricing-studio'
      fullPath: '/sales-tools/pricing-studio'
      preLoaderRoute: typeof SalesToolsPricingStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/activity': {
      id: '/sales/activity'
      path: '/sales/activity'
      fullPath: '/sales/activity'
      preLoaderRoute: typeof SalesActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/book-onboarding': {
      id: '/sales/book-onboarding'
      path: '/sales/book-onboarding'
      fullPath: '/sales/book-onboarding'
      preLoaderRoute: typeof SalesBookOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/pipeline': {
      id: '/sales/pipeline'
      path: '/sales/pipeline'
      fullPath: '/sales/pipeline'
      preLoaderRoute: typeof SalesPipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/scorecard': {
      id: '/sales/scorecard'
      path: '/sales/scorecard'
      fullPath: '/sales/scorecard'
      preLoaderRoute: typeof SalesScorecardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/win-loss': {
      id: '/sales/win-loss'
      path: '/sales/win-loss'
      fullPath: '/sales/win-loss'
      preLoaderRoute: typeof SalesWinLossRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/dashboard': {
      id: '/studio/dashboard'
      path: '/studio/dashboard'
      fullPath: '/studio/dashboard'
      preLoaderRoute: typeof StudioDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/deck': {
      id: '/studio/deck'
      path: '/studio/deck'
      fullPath: '/studio/deck'
      preLoaderRoute: typeof StudioDeckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/library': {
      id: '/studio/library'
      path: '/studio/library'
      fullPath: '/studio/library'
      preLoaderRoute: typeof StudioLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/report': {
      id: '/studio/report'
      path: '/studio/report'
      fullPath: '/studio/report'
      preLoaderRoute: typeof StudioReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/tv': {
      id: '/studio/tv'
      path: '/studio/tv'
      fullPath: '/studio/tv'
      preLoaderRoute: typeof StudioTvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/duplicate-ach': {
      id: '/transaction-monitoring/duplicate-ach'
      path: '/transaction-monitoring/duplicate-ach'
      fullPath: '/transaction-monitoring/duplicate-ach'
      preLoaderRoute: typeof TransactionMonitoringDuplicateAchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/duplicate-cards': {
      id: '/transaction-monitoring/duplicate-cards'
      path: '/transaction-monitoring/duplicate-cards'
      fullPath: '/transaction-monitoring/duplicate-cards'
      preLoaderRoute: typeof TransactionMonitoringDuplicateCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/duplicate-payments': {
      id: '/transaction-monitoring/duplicate-payments'
      path: '/transaction-monitoring/duplicate-payments'
      fullPath: '/transaction-monitoring/duplicate-payments'
      preLoaderRoute: typeof TransactionMonitoringDuplicatePaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/high-low-tickets': {
      id: '/transaction-monitoring/high-low-tickets'
      path: '/transaction-monitoring/high-low-tickets'
      fullPath: '/transaction-monitoring/high-low-tickets'
      preLoaderRoute: typeof TransactionMonitoringHighLowTicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/owner-payments': {
      id: '/transaction-monitoring/owner-payments'
      path: '/transaction-monitoring/owner-payments'
      fullPath: '/transaction-monitoring/owner-payments'
      preLoaderRoute: typeof TransactionMonitoringOwnerPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/repeat-card-usage': {
      id: '/transaction-monitoring/repeat-card-usage'
      path: '/transaction-monitoring/repeat-card-usage'
      fullPath: '/transaction-monitoring/repeat-card-usage'
      preLoaderRoute: typeof TransactionMonitoringRepeatCardUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transaction-monitoring/same-day-repeats': {
      id: '/transaction-monitoring/same-day-repeats'
      path: '/transaction-monitoring/same-day-repeats'
      fullPath: '/transaction-monitoring/same-day-repeats'
      preLoaderRoute: typeof TransactionMonitoringSameDayRepeatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/displays_/$name': {
      id: '/platform/displays_/$name'
      path: '/platform/displays/$name'
      fullPath: '/platform/displays/$name'
      preLoaderRoute: typeof PlatformDisplaysNameRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DisplayVideoRoute: DisplayVideoRoute,
  AchDailyRoute: AchDailyRoute,
  AchMerchantRejectionsRoute: AchMerchantRejectionsRoute,
  AchNachaRatesRoute: AchNachaRatesRoute,
  AchReasonCodesRoute: AchReasonCodesRoute,
  AchReturnReasonsRoute: AchReturnReasonsRoute,
  AchReturnsRoute: AchReturnsRoute,
  AchTrendsRoute: AchTrendsRoute,
  AchVolumeTrendsRoute: AchVolumeTrendsRoute,
  AlertsRulesRoute: AlertsRulesRoute,
  BusinessPerformanceClientScorecardRoute:
    BusinessPerformanceClientScorecardRoute,
  BusinessPerformanceDmsVolumeRoute: BusinessPerformanceDmsVolumeRoute,
  BusinessPerformanceFeatureAdoptionRoute:
    BusinessPerformanceFeatureAdoptionRoute,
  BusinessPerformanceGoLiveRampUpRoute: BusinessPerformanceGoLiveRampUpRoute,
  BusinessPerformanceMerchantWeeklyTiersRoute:
    BusinessPerformanceMerchantWeeklyTiersRoute,
  BusinessPerformancePaymentOriginRoute: BusinessPerformancePaymentOriginRoute,
  BusinessPerformancePlatformActivityRoute:
    BusinessPerformancePlatformActivityRoute,
  BusinessPerformanceTpvTcvPeaksRoute: BusinessPerformanceTpvTcvPeaksRoute,
  BusinessPerformanceWeeklyTrendsRoute: BusinessPerformanceWeeklyTrendsRoute,
  CollectionsAccountDelinquencyRoute: CollectionsAccountDelinquencyRoute,
  CollectionsAiDeclineImpactRoute: CollectionsAiDeclineImpactRoute,
  CollectionsAiDeclineJourneysRoute: CollectionsAiDeclineJourneysRoute,
  CollectionsBlytzcollectAnalyticsRoute: CollectionsBlytzcollectAnalyticsRoute,
  CollectionsPropensityAccuracyRoute: CollectionsPropensityAccuracyRoute,
  CollectionsPropensityToPayRoute: CollectionsPropensityToPayRoute,
  CollectionsScorecardRoute: CollectionsScorecardRoute,
  CompanyTvBoardRoute: CompanyTvBoardRoute,
  CsToolsAccountChangeLogRoute: CsToolsAccountChangeLogRoute,
  CsToolsAutopayAccountsRoute: CsToolsAutopayAccountsRoute,
  CsToolsCustomerListRoute: CsToolsCustomerListRoute,
  CsToolsFollowUpReportRoute: CsToolsFollowUpReportRoute,
  CsToolsInboundMessagesRoute: CsToolsInboundMessagesRoute,
  CsToolsMerchantNotesRoute: CsToolsMerchantNotesRoute,
  CsToolsMerchantUsersRoute: CsToolsMerchantUsersRoute,
  CsToolsMessageReportRoute: CsToolsMessageReportRoute,
  CsToolsOptOutSourcesRoute: CsToolsOptOutSourcesRoute,
  CsToolsOptOutsRoute: CsToolsOptOutsRoute,
  CsToolsPaymentOriginShareRoute: CsToolsPaymentOriginShareRoute,
  CsToolsPaymentReportRoute: CsToolsPaymentReportRoute,
  CsToolsReconciliationRoute: CsToolsReconciliationRoute,
  CsToolsRegistrationsRoute: CsToolsRegistrationsRoute,
  CsToolsTwilioRepliesRoute: CsToolsTwilioRepliesRoute,
  CsToolsUndeliveredRoute: CsToolsUndeliveredRoute,
  DisplayNameRoute: DisplayNameRoute,
  EngineeringAgentBoardRoute: EngineeringAgentBoardRoute,
  EngineeringServicePerformanceRoute: EngineeringServicePerformanceRoute,
  EngineeringUnansweredQuestionsRoute: EngineeringUnansweredQuestionsRoute,
  LabReportChatRoute: LabReportChatRoute,
  LabReportDraftRoute: LabReportDraftRoute,
  LabReportDraftsRoute: LabReportDraftsRoute,
  MerchantsHubspotSyncRoute: MerchantsHubspotSyncRoute,
  MerchantsLocationLookupRoute: MerchantsLocationLookupRoute,
  MerchantsLocationsRoute: MerchantsLocationsRoute,
  MerchantsMasterListRoute: MerchantsMasterListRoute,
  MerchantsMerchant360Route: MerchantsMerchant360Route,
  MerchantsMerchantSettingsRoute: MerchantsMerchantSettingsRoute,
  MerchantsMmpvRoute: MerchantsMmpvRoute,
  MerchantsOnboardingPipelineRoute: MerchantsOnboardingPipelineRoute,
  MerchantsPortfolioCalloutsRoute: MerchantsPortfolioCalloutsRoute,
  MerchantsProcessorsRoute: MerchantsProcessorsRoute,
  MerchantsRewindRoute: MerchantsRewindRoute,
  PaymentsAiDeclineCodesRoute: PaymentsAiDeclineCodesRoute,
  PaymentsBinMccFeeReportRoute: PaymentsBinMccFeeReportRoute,
  PaymentsMulticardUsageRoute: PaymentsMulticardUsageRoute,
  PaymentsPayerExperienceRoute: PaymentsPayerExperienceRoute,
  PaymentsRetryAnalysisRoute: PaymentsRetryAnalysisRoute,
  PaymentsRetryAnalysisTsysRoute: PaymentsRetryAnalysisTsysRoute,
  PlatformDisplaysRoute: PlatformDisplaysRoute,
  PlatformJobsRoute: PlatformJobsRoute,
  ProductAiTextsRoute: ProductAiTextsRoute,
  ProductDeclinePaymentJourneyRoute: ProductDeclinePaymentJourneyRoute,
  ProductRequestTriageRoute: ProductRequestTriageRoute,
  ProductRequestsRoute: ProductRequestsRoute,
  RiskChargebackDisputesRoute: RiskChargebackDisputesRoute,
  RiskChargebacksByOriginRoute: RiskChargebacksByOriginRoute,
  RiskChargebacksOverviewRoute: RiskChargebacksOverviewRoute,
  RiskDeclineByMidRoute: RiskDeclineByMidRoute,
  RiskDeclineRetriesRoute: RiskDeclineRetriesRoute,
  RiskDeclinesRoute: RiskDeclinesRoute,
  RiskMerchantOutliersRoute: RiskMerchantOutliersRoute,
  RiskMerchantProfileRoute: RiskMerchantProfileRoute,
  RiskMerchantRiskRoute: RiskMerchantRiskRoute,
  RiskPortfolioRiskKpisRoute: RiskPortfolioRiskKpisRoute,
  RiskTransactionScoringRoute: RiskTransactionScoringRoute,
  SalesToolsPricingStudioRoute: SalesToolsPricingStudioRoute,
  SalesActivityRoute: SalesActivityRoute,
  SalesBookOnboardingRoute: SalesBookOnboardingRoute,
  SalesPipelineRoute: SalesPipelineRoute,
  SalesScorecardRoute: SalesScorecardRoute,
  SalesWinLossRoute: SalesWinLossRoute,
  StudioDashboardRoute: StudioDashboardRoute,
  StudioDeckRoute: StudioDeckRoute,
  StudioLibraryRoute: StudioLibraryRoute,
  StudioReportRoute: StudioReportRoute,
  StudioTvRoute: StudioTvRoute,
  TransactionMonitoringDuplicateAchRoute:
    TransactionMonitoringDuplicateAchRoute,
  TransactionMonitoringDuplicateCardsRoute:
    TransactionMonitoringDuplicateCardsRoute,
  TransactionMonitoringDuplicatePaymentsRoute:
    TransactionMonitoringDuplicatePaymentsRoute,
  TransactionMonitoringHighLowTicketsRoute:
    TransactionMonitoringHighLowTicketsRoute,
  TransactionMonitoringOwnerPaymentsRoute:
    TransactionMonitoringOwnerPaymentsRoute,
  TransactionMonitoringRepeatCardUsageRoute:
    TransactionMonitoringRepeatCardUsageRoute,
  TransactionMonitoringSameDayRepeatsRoute:
    TransactionMonitoringSameDayRepeatsRoute,
  PlatformDisplaysNameRoute: PlatformDisplaysNameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
